{
  "version": 1,
  "asset_id": "51762727-9821-4789-8b54-a3e776c50aab",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/51762727-9821-4789-8b54-a3e776c50aab/revision-hub-annotated-1600.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/51762727-9821-4789-8b54-a3e776c50aab/revision-hub-annotated-1600.jpg",
  "original_filename": "revision-hub-annotated-1600.jpg",
  "size": 195181,
  "content_type": "image/jpeg",
  "created_at": "2026-10-05T21:16:59Z"
}
